import { BRAND_SYMBOLS } from '../../../constants/horseConstants';

/**
 * Brand symbol selector component
 * Allows selecting up to 8 brand symbols for a horse
 */
const BrandSymbolSelector = ({ selectedSymbols = [], onChange }) => {
  // Ensure selectedSymbols is always an array
  const safeSymbols = Array.isArray(selectedSymbols) ? selectedSymbols : [];
  
  const handleAddSymbol = (symbolUrl) => {
    if (!onChange) return;
    if (safeSymbols.length < 8) {
      onChange([...safeSymbols, symbolUrl]);
    }
  };

  const handleRemoveSymbol = (index) => {
    if (!onChange) return;
    const newSymbols = [...safeSymbols];
    newSymbols.splice(index, 1);
    onChange(newSymbols);
  };

  // Safety check for BRAND_SYMBOLS
  const availableSymbols = Array.isArray(BRAND_SYMBOLS) ? BRAND_SYMBOLS : [];

  return (
    <div className="space-y-4">
      {/* Selected Symbols Display (8 slots) */}
      <div>
        <label className="block text-sm font-medium mb-2">
          Brand Symbols (max 8)
        </label>
        <div className="grid grid-cols-4 gap-3">
          {[...Array(8)].map((_, idx) => (
            <div
              key={idx}
              className="relative aspect-square rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-center bg-gray-50"
            >
              {safeSymbols[idx] ? (
                <>
                  <img 
                    src={safeSymbols[idx]} 
                    alt={`Slot ${idx + 1}`}
                    className="w-10 h-10 object-contain"
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                  <button
                    type="button"
                    onClick={() => handleRemoveSymbol(idx)}
                    className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 text-xs hover:bg-red-600 font-bold"
                    title="Remove this symbol"
                  >
                    ×
                  </button>
                </>
              ) : (
                <span className="text-gray-400 text-xs">{idx + 1}</span>
              )}
            </div>
          ))}
        </div>
      </div>
      
      {/* Available Symbols to Choose From */}
      {availableSymbols.length > 0 && (
        <div>
          <p className="text-xs font-medium text-gray-700 mb-2">
            Click to add symbols:
          </p>
          <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 gap-3">
            {availableSymbols.map((symbol) => {
              if (!symbol || !symbol.id || !symbol.url) return null;
              
              const isDisabled = safeSymbols.length >= 8;
              
              return (
                <button
                  key={symbol.id}
                  type="button"
                  onClick={() => handleAddSymbol(symbol.url)}
                  disabled={isDisabled}
                  className={`
                    aspect-square rounded-lg border-2 p-2 transition-all
                    ${isDisabled ? 'opacity-40 cursor-not-allowed border-gray-300' : 'hover:border-blue-400 hover:bg-blue-50 cursor-pointer border-gray-300'}
                  `}
                  title={isDisabled ? 'All 8 slots filled' : `Add ${symbol.name || 'symbol'}`}
                >
                  <img 
                    src={symbol.url} 
                    alt={symbol.name || 'Brand symbol'}
                    className="w-full h-full object-contain"
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default BrandSymbolSelector;
